import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const UpsRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.ups"
        components={{
          phone: (
            <a href={`tel:1-800-782-7892`} className="email_space">
              1-800-782-7892
            </a>
          ),
        }}
      />
    </div>
  );
};

export default UpsRequirements;
